import selectRawProduct from '../select-raw-product';

// @ts-expect-error - Automatic, Please fix when editing this file
const selectProductsError = (state) => selectRawProduct(state)?.error ?? null;

export default selectProductsError;
